// Pre-computed aggregate data across 7,647 strain JSON files
// Generated by analyze_strains.py — do not edit by hand

export const TOTALS = {
  strains: 7647,
  reviews: 478306,
  followers: 10813045,
  meanRating: 4.502,
  medianRating: 4.53,
};

// Top 25 flavors sorted by total vote count
// score = average community sentiment score (higher = more positively received)
export const FLAVORS = [
  { name: 'Earthy',        votes: 68758, score:  0.191, appearances: 5110 },
  { name: 'Sweet',         votes: 61405, score:  0.172, appearances: 4530 },
  { name: 'Citrus',        votes: 40755, score: -0.007, appearances: 4199 },
  { name: 'Pungent',       votes: 36382, score:  0.005, appearances: 3779 },
  { name: 'Berry',         votes: 29587, score:  0.801, appearances: 3567 },
  { name: 'Pine',          votes: 29363, score:  0.051, appearances: 3563 },
  { name: 'Woody',         votes: 26763, score: -0.023, appearances: 3620 },
  { name: 'Flowery',       votes: 26199, score: -0.232, appearances: 3868 },
  { name: 'Diesel',        votes: 22529, score:  0.997, appearances: 3401 },
  { name: 'Lemon',         votes: 21375, score:  0.395, appearances: 2884 },
  { name: 'Skunk',         votes: 20463, score: -0.163, appearances: 3075 },
  { name: 'Tropical',      votes: 14994, score:  0.046, appearances: 2564 },
  { name: 'Blueberry',     votes: 13731, score:  0.949, appearances: 2036 },
  { name: 'Spicy/Herbal',  votes: 11427, score: -0.959, appearances: 1631 },
  { name: 'Grape',         votes: 11418, score:  0.565, appearances: 1771 },
  { name: 'Pepper',        votes: 11196, score: -0.617, appearances: 2534 },
  { name: 'Chemical',      votes:  9558, score:  0.071, appearances: 2570 },
  { name: 'Orange',        votes:  9077, score:  0.097, appearances: 1675 },
  { name: 'Vanilla',       votes:  7993, score:  0.207, appearances: 1836 },
  { name: 'Nutty',         votes:  7529, score: -0.616, appearances: 2077 },
  { name: 'Mint',          votes:  6912, score: -0.009, appearances: 1675 },
  { name: 'Cheese',        votes:  6823, score:  0.547, appearances: 1695 },
  { name: 'Lime',          votes:  6505, score: -0.506, appearances: 1701 },
  { name: 'Pineapple',     votes:  5874, score:  0.482, appearances: 1126 },
  { name: 'Strawberry',    votes:  5180, score:  0.523, appearances: 1016 },
];

// All 13 effects, sorted by total vote count
export const EFFECTS = [
  { name: 'Relaxed',   votes: 219312, score: 0.495, appearances: 6445 },
  { name: 'Happy',     votes: 208575, score: 0.698, appearances: 6254 },
  { name: 'Euphoric',  votes: 183265, score: 0.678, appearances: 6139 },
  { name: 'Uplifted',  votes: 159043, score: 0.734, appearances: 5904 },
  { name: 'Creative',  votes: 107225, score: 0.750, appearances: 5352 },
  { name: 'Focused',   votes:  97214, score: 0.604, appearances: 5386 },
  { name: 'Energetic', votes:  97100, score: 0.864, appearances: 4908 },
  { name: 'Sleepy',    votes:  91123, score: 0.298, appearances: 4790 },
  { name: 'Hungry',    votes:  88262, score: 0.353, appearances: 5003 },
  { name: 'Giggly',    votes:  78356, score: 0.358, appearances: 4946 },
  { name: 'Talkative', votes:  76433, score: 0.507, appearances: 4780 },
  { name: 'Tingly',    votes:  67998, score: 0.043, appearances: 4881 },
  { name: 'Aroused',   votes:  46389, score: 0.101, appearances: 4233 },
];

// How many strains list each effect as their #1 dominant effect
export const TOP_EFFECTS_BY_STRAIN = [
  { name: 'Sleepy',    count: 844 },
  { name: 'Aroused',   count: 570 },
  { name: 'Tingly',    count: 552 },
  { name: 'Energetic', count: 550 },
  { name: 'Hungry',    count: 484 },
  { name: 'Focused',   count: 481 },
  { name: 'Talkative', count: 470 },
  { name: 'Relaxed',   count: 452 },
  { name: 'Giggly',    count: 426 },
  { name: 'Uplifted',  count: 393 },
  { name: 'Euphoric',  count: 384 },
  { name: 'Creative',  count: 327 },
  { name: 'Happy',     count: 304 },
];

// Medical conditions, sorted by total votes
export const CONDITIONS = [
  { name: 'Anxiety',                  votes: 109344, score:  0.484 },
  { name: 'PTSD',                     votes:  35736, score: -0.213 },
  { name: 'Migraines',                votes:  27386, score: -0.255 },
  { name: 'ADD/ADHD',                 votes:  24807, score: -0.527 },
  { name: 'Bipolar disorder',         votes:  23391, score: -0.179 },
  { name: 'Arthritis',                votes:  22062, score: -0.345 },
  { name: 'PMS',                      votes:  13422, score: -0.589 },
  { name: 'Gastrointestinal',         votes:  12612, score: -0.737 },
  { name: 'Fibromyalgia',             votes:  12027, score: -0.682 },
  { name: 'Hypertension',             votes:   9161, score: -0.705 },
  { name: 'Spinal cord injury',       votes:   8963, score: -0.817 },
  { name: 'Anorexia',                 votes:   7813, score: -0.726 },
  { name: 'Asthma',                   votes:   7043, score: -0.768 },
  { name: 'Cancer',                   votes:   5877, score: -0.805 },
  { name: 'Tinnitus',                 votes:   4814, score: -1.004 },
];

// Symptoms helped, sorted by total votes
export const SYMPTOMS = [
  { name: 'Stress',           votes: 118879, score:  0.470 },
  { name: 'Depression',       votes:  91314, score:  0.449 },
  { name: 'Pain',             votes:  90075, score:  0.258 },
  { name: 'Insomnia',         votes:  56333, score:  0.018 },
  { name: 'Lack of appetite', votes:  39477, score: -0.118 },
  { name: 'Fatigue',          votes:  35998, score:  0.087 },
  { name: 'Nausea',           votes:  35033, score: -0.169 },
  { name: 'Headaches',        votes:  33820, score: -0.121 },
  { name: 'Muscle spasms',    votes:  27190, score: -0.418 },
  { name: 'Inflammation',     votes:  24930, score: -0.500 },
  { name: 'Cramps',           votes:  14962, score: -0.519 },
  { name: 'Eye pressure',     votes:  10602, score: -0.644 },
  { name: 'Spasticity',       votes:   7559, score: -0.824 },
  { name: 'Seizures',         votes:   5604, score: -0.894 },
];

// Negative side effects (all 6 in dataset)
export const NEGATIVES = [
  { name: 'Dry mouth', votes: 90790 },
  { name: 'Dry eyes',  votes: 50622 },
  { name: 'Dizzy',     votes: 22142 },
  { name: 'Paranoid',  votes: 18233 },
  { name: 'Anxious',   votes: 15010 },
  { name: 'Headache',  votes: 12829 },
];

// Terpenes — appear across 3,598 strains, ranked by average score
export const TERPENES = [
  { name: 'Myrcene',       strains: 3598, avgScore: 0.4350, description: 'Most common terpene; earthy, musky, herbal aroma.' },
  { name: 'Caryophyllene', strains: 3598, avgScore: 0.3530, description: 'Spicy, peppery — also found in black pepper. Anti-inflammatory.' },
  { name: 'Limonene',      strains: 3598, avgScore: 0.2860, description: 'Citrus-scented; associated with mood elevation & stress relief.' },
  { name: 'Pinene',        strains: 3598, avgScore: 0.2020, description: 'Pine-scented; may improve airflow and memory retention.' },
  { name: 'Humulene',      strains: 3598, avgScore: 0.1180, description: 'Herbal, earthy notes; potential anti-inflammatory properties.' },
  { name: 'Linalool',      strains: 3598, avgScore: 0.1080, description: 'Floral, found in lavender; promotes relaxation.' },
  { name: 'Terpinolene',   strains: 3598, avgScore: 0.0880, description: 'Fresh, floral, herbal — found in apples, lilacs, and nutmeg.' },
  { name: 'Ocimene',       strains: 3598, avgScore: 0.0450, description: 'Sweet, herbaceous, woody scent; used in perfumes.' },
];

// Cannabinoids — percentile50 averages (non-zero strains only)
export const CANNABINOIDS = [
  { name: 'THC',  displayName: 'THC',   strains: 3941, mean: 19.73, median: 20.00, max: 37.0, color: '#f59e0b' },
  { name: 'CBD',  displayName: 'CBD',   strains:  100, mean:  8.84, median:  9.00, max: 18.0, color: '#34d399' },
  { name: 'THCV', displayName: 'THCV',  strains:   28, mean:  1.82, median:  1.00, max: 13.0, color: '#a78bfa' },
  { name: 'CBC',  displayName: 'CBC',   strains:   15, mean:  1.13, median:  1.00, max:  3.0, color: '#60a5fa' },
  { name: 'CBG',  displayName: 'CBG',   strains: 2422, mean:  1.10, median:  1.00, max: 10.0, color: '#fb923c' },
];

// Strain category split
export const CATEGORIES = [
  { name: 'Hybrid',  count: 5638, color: '#4ade80' },
  { name: 'Indica',  count:  933, color: '#a78bfa' },
  { name: 'Sativa',  count:  584, color: '#fb923c' },
  { name: 'Unknown', count:  492, color: '#64748b' },
];
